class Overlay {
  constructor() {
    this.initialise();
  }

  initialise() {
    document.body.classList.add('overflow-hidden');

    this.overlay = document.createElement('div');
    this.overlay.setAttribute('data-overlay', '');
    this.overlay.className = 'overlay';
    this.overlay.innerHTML = `
      <svg class="loading-spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <g fill="currentColor"><g><path d="M24 47a23 23 0 1 1 23-23 23.025 23.025 0 0 1-23 23zm0-42a19 19 0 1 0 19 19A19.021 19.021 0 0 0 24 5z" opacity=".4"></path><path d="M47 24h-4A19.021 19.021 0 0 0 24 5V1a23.025 23.025 0 0 1 23 23z"></path></g></g>
      </svg>
    `;

    document.body.appendChild(this.overlay);

    this.overlay.addEventListener('click', this.handleClick.bind(this));

    setTimeout(() => {
      this.overlay.classList.add('active');
    }, 10);
  }

  handleClick(e) {
    if (e.target.closest('[data-overlay]') === null) return;

    this.close();

    if (window.drawer) {
      window.drawers.activeDrawer = false;
    }

    if (window.popup) {
      window.popup.close();
    }
  }

  close() {
    this.overlay.classList.remove('active');

    document.body.classList.remove('overflow-hidden');

    this.overlay.addEventListener(
      'transitionend',
      () => {
        this.destroy();
      },
      { once: true }
    );
  }

  destroy() {
    this.overlay.remove();

    window.overlay = false;
  }

  get el() {
    return this.overlay;
  }

  set loading(val) {
    this.overlay.classList.toggle('loading', val);
  }
}